import { Company, CombinedUser } from "shared"

interface BrandingMenuItem {
	label: string
	href: string
}

interface BrandingPermissions {
	placeholderTags?: boolean
	uniqueLinks?: boolean
	brandingAccess?: "write" | "read" | "none"
}

export function getBrandingMenuItems(
	permissions: BrandingPermissions,
	user: CombinedUser,
	company: Company
): BrandingMenuItem[] {
	const brandingAccess = permissions.brandingAccess || "none"
	const items: BrandingMenuItem[] = []

	// Content Templates - available to all users (none, read, write)
	items.push({ label: "Templates", href: "/branding/Templates" })

	// Tags & Prompts - available to read and write users only
	if (brandingAccess === "read" || brandingAccess === "write") {
		items.push({ label: "AI Builder", href: "/branding/AI Builder" })

		// Add Placeholder Tags if enabled
		if (permissions.placeholderTags) {
			items.push({ label: "Placeholder Tags", href: "/branding/Placeholder Tags" })
		}

		// Add CRM Field Mapping if user is admin and has integrations
		const hasIntegrations =
			user?.role === "admin" &&
			Object.values(company?.options?.outputs || {}).some(
				(item: any) =>
					item.integrationType &&
					(item.integrationType === "arcrm" ||
						item.integrationType === "vincere" ||
						item.integrationType === "bullhorn")
			)

		if (hasIntegrations) {
			items.push({ label: "CRM Field Mapping", href: "/branding/CRM Field Mapping" })
		}
	}

	// Brand Settings - available for write permissions only
	if (brandingAccess === "write") {
		items.push(
			{ label: "Fonts", href: "/branding/Fonts" },
			{ label: "Brand Defaults", href: "/branding/Brand Defaults" }
		)

		// Add Landing Pages if enabled (only for write permissions)
		if (permissions.uniqueLinks) {
			items.push({ label: "Landing Pages", href: "/branding/Landing Pages" })
		}
	}

	return items
}
